
import { Button, Col, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { CalendarOutlined, ClockCircleOutlined, EnvironmentOutlined } from "@ant-design/icons";
import SupOtRequestForm from "features/employee/components/SupOtRequestForm";
import SupOffsiteRequestForm from "features/employee/components/SupOffsiteRequestForm";
import SupLeaveRequestForm from "features/employee/components/SupLeaveRequestForm";

const HomeDayRequestModal = ({
    isOpen = false,
    onClose = () => { },
    selectedDate = "",
    selectedEmployee = "",
    initialForm = null,
    selectedOtTime = "",
    selectedOtTimeEnd = "",
    workTypeOptions = [],
    onAttachFileChange = () => { },
    setpreviousFilew = () => { },
    handleOffSiteModalSubmit = () => { },
    handleLeaveModalSubmit = () => { },
    handleOtModalSubmit = () => { },
    leaveGroupOptions = [],
    selectedShift = "",
    employeeName = null,
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm(null);
    const [selectedForm, setSelectedForm] = useState(null);

    useEffect(() => {
        if (isOpen && selectedDate) {
            form.setFieldsValue({ startDate: dayjs(selectedDate) });
        }
        if (isOpen) {
            setSelectedForm(initialForm);
        }
        if (!isOpen) {
            setSelectedForm(null);
        }
    }, [isOpen, selectedDate, form, initialForm]);

    const renderTitle = useCallback(() => {
        return (
            <Flex vertical>
                {!selectedForm ? (
                    <>
                        <span style={{ fontSize: "18px", color: "#42526D" }}>
                            {i18n.language === "en"
                                ? dayjs(selectedDate).format("DD/MM/YYYY")
                                : dayjs(selectedDate).format("DD/MM/BBBB")}
                        </span>
                        <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                            {`${t("shift.header")} ${selectedShift}`}
                        </span>
                    </>
                ) : (
                    <>
                        <span style={{ fontSize: "18px", color: "#42526D" }}>
                            {selectedForm === "ot" && t("employment-information.label.ot_request")}
                            {selectedForm === "leave" && t("calendar.label.leave_request")}
                            {selectedForm === "offSite" && t("calendar.label.out_site_work_request")}
                        </span>
                        <Flex gap={8}>
                            <span style={{ color: "#667085", fontSize: "14px", fontWeight: "normal" }}>
                                {`${t("employee.label.employee-name")} :`}
                            </span>
                            <span style={{ color: "#42526D", fontSize: "14px", fontWeight: "normal" }}>
                                {employeeName}
                            </span>
                        </Flex>
                    </>
                )}
            </Flex>
        );
    }, [selectedForm, i18n.language, selectedDate, t, selectedShift, employeeName]);

    const requestTypeOptions = [
        {
            key: "leave",
            label: t("calendar.label.leave_request"),
            icon: <CalendarOutlined />,
            // iconBg: "#ffdddb",
            iconFg: "#D60D0D",
        },
        {
            key: "ot",
            label: t("employment-information.label.ot_request"),
            icon: <ClockCircleOutlined />,
            // iconBg: "#D1FAE5",
            iconFg: "#5A1BC4",
        },
        {
            key: "offSite",
            label: t("calendar.label.out_site_work_request"),
            icon: <EnvironmentOutlined />,
            // iconBg: "#EDE9FE",
            iconFg: "#0F7D25",
        },
    ];

    return (
        <Modal
            title={renderTitle()}
            maskClosable={false}
            open={isOpen}
            footer={false}
            onCancel={onClose}
            width={458}
        >
            {!selectedForm && (
                <Flex vertical gap={16} style={{ marginTop: "24px" }}>
                    {requestTypeOptions.map((opt) => (
                        <Flex key={opt.key} align="center" gap={12}>
                            <Flex
                                align="center"
                                justify="center"
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundColor: opt.iconBg,
                                    color: opt.iconFg,
                                    fontSize: 18,
                                    flexShrink: 0,
                                }}
                            >
                                {opt.icon}
                            </Flex>
                            <Button
                                style={{ width: "100%", borderRadius: "5px", borderColor: "#E4E4E4", color: "#344054" }}
                                size="large"
                                onClick={() => setSelectedForm(opt.key)}
                            >
                                {opt.label}
                            </Button>
                        </Flex>
                    ))}
                </Flex>
            )}

            <Space direction="vertical" style={{ width: "100%", marginTop: "16px" }}>
                {selectedForm === "leave" && (
                    <SupLeaveRequestForm
                        isOpen={isOpen}
                        onClose={() => {
                            setSelectedForm(null);
                            onClose();
                        }}
                        selectedDate={selectedDate}
                        leaveGroupOptions={leaveGroupOptions}
                        onAttachFileChange={onAttachFileChange}
                        setpreviousFilew={setpreviousFilew}
                        handleLeaveModalSubmit={handleLeaveModalSubmit}
                    />
                )}

                {selectedForm === "ot" && (
                    <SupOtRequestForm
                        isOpen={isOpen}
                        onClose={() => {
                            setSelectedForm(null);
                            onClose();
                        }}
                        onSubmit={handleOtModalSubmit}
                        selectedDate={selectedDate}
                        selectedEmployee={selectedEmployee}
                        onAttachFileChange={onAttachFileChange}
                        setpreviousFilew={setpreviousFilew}
                        selectedOtTime={selectedOtTime}
                        selectedOtTimeEnd={selectedOtTimeEnd}
                    />
                )}

                {selectedForm === "offSite" && (
                    <SupOffsiteRequestForm
                        isOpen={isOpen}
                        onClose={() => {
                            setSelectedForm(null);
                            onClose();
                        }}
                        workTypeOptions={workTypeOptions}
                        onAttachFileChange={onAttachFileChange}
                        setpreviousFilew={setpreviousFilew}
                        handleOffSiteModalSubmit={handleOffSiteModalSubmit}
                        selectedDate={selectedDate}
                    />
                )}
            </Space>
        </Modal>
    );
};

export default HomeDayRequestModal;